'use es6';

import PropTypes from 'prop-types';
import { Component, memo } from 'react';
import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import { BATTLESHIP, CALYPSO, CALYPSO_LIGHT, OLAF } from 'HubStyleTokens/colors';
import { GridSize } from '../../constants/table';
import { SUBMENU_CLOSE_CLASSNAME, SUBMENU_STAY_OPEN_CLASSNAME } from '../../constants/toolbar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PopoverBody = styled.div.withConfig({
  displayName: "TableInsertPopoverBody__PopoverBody",
  componentId: "ztf1ed-0"
})(["padding:0 8px;"]);
const TableSizeLabel = styled.p.withConfig({
  displayName: "TableInsertPopoverBody__TableSizeLabel",
  componentId: "ztf1ed-1"
})(["text-align:center !important;margin-top:6px;margin-bottom:0;user-select:none;"]);
const SquatchCell = styled.div.withConfig({
  displayName: "TableInsertPopoverBody__SquatchCell",
  componentId: "ztf1ed-2"
})(["padding:8px !important;margin-top:", " !important;margin-left:", " !important;box-shadow:none !important;background-color:", ";border-color:", ";border-radius:3px;border-style:solid;border-width:1px;display:inline-block;position:relative;width:auto;user-select:none;cursor:pointer;"], ({
  marginTop
}) => marginTop ? '2px' : 0, ({
  marginLeft
}) => marginLeft ? '2px' : 0, ({
  hovered
}) => hovered ? CALYPSO_LIGHT : OLAF, ({
  hovered
}) => hovered ? CALYPSO : BATTLESHIP);
const GridCell = /*#__PURE__*/memo(props => {
  const {
    row,
    col,
    hovered
  } = props;
  const handleMouseOver = () => {
    props.onMouseOver({
      row,
      col
    });
  };
  const handleClick = () => {
    props.onClick({
      row,
      col
    });
  };
  return /*#__PURE__*/_jsx(SquatchCell, {
    className: SUBMENU_CLOSE_CLASSNAME,
    hovered: hovered,
    marginTop: row > 1,
    marginLeft: col > 1,
    onMouseOver: handleMouseOver,
    onClick: handleClick
  });
});
export default class TableInsertPopoverBody extends Component {
  constructor(props) {
    super(props);
    this.handleCellClick = ({
      row,
      col
    }) => {
      const {
        onInsertTable
      } = this.props;
      onInsertTable(col, row);
    };
    this.handleCellHover = ({
      row,
      col
    }) => {
      this.setState({
        hoveredCell: {
          row,
          col
        },
        gridSize: {
          rows: Math.max(GridSize.MIN, Math.min(GridSize.MAX, row + 1)),
          cols: Math.max(GridSize.MIN, Math.min(GridSize.MAX, col + 1))
        }
      });
    };
    this.state = {
      hoveredCell: {
        row: 0,
        col: 0
      },
      gridSize: {
        rows: GridSize.MIN,
        cols: GridSize.MIN
      }
    };
  }
  getTableGrid() {
    const {
      hoveredCell,
      gridSize
    } = this.state;
    const grid = [];
    for (let row = 1; row <= gridSize.rows; row++) {
      const cells = [];
      for (let col = 1; col <= gridSize.cols; col++) {
        const hovered = row <= hoveredCell.row && col <= hoveredCell.col;
        cells.push( /*#__PURE__*/_jsx(GridCell, {
          row: row,
          col: col,
          hovered: hovered,
          onMouseOver: this.handleCellHover,
          onClick: this.handleCellClick
        }, `cell-${col}-${row}`));
      }
      grid.push( /*#__PURE__*/_jsx(UIFlex, {
        children: cells
      }, row));
    }
    return grid;
  }
  render() {
    const grid = this.getTableGrid();
    const {
      hoveredCell
    } = this.state;
    return /*#__PURE__*/_jsxs(PopoverBody, {
      className: SUBMENU_STAY_OPEN_CLASSNAME,
      children: [grid, /*#__PURE__*/_jsx(TableSizeLabel, {
        children: `${hoveredCell.col} x ${hoveredCell.row}`
      })]
    });
  }
}
TableInsertPopoverBody.propTypes = {
  onInsertTable: PropTypes.func.isRequired
};